type Props = { props: Record<string, string | number | boolean> }

export function TextPreview({ props: p }: Props) {
  return (
    <p
      className="text-tf-text-sub"
      style={{
        textAlign: p.align as 'left' | 'center' | 'right',
        fontSize: `${p.fontSize}px`,
      }}
    >
      {p.content as string}
    </p>
  )
}
